import { render, staticRenderFns } from "./ReviewsStats.vue?vue&type=template&id=6284c7f9&"
import script from "./ReviewsStats.vue?vue&type=script&lang=js&"
export * from "./ReviewsStats.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsStats.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports